import React from "react";
import styles from "../InverluxApps.module.css";

// The Web Store item is still a draft; activate this CTA once a public URL is verified.
const TinyJpgPngStoreButton = () => (
  <button
    className={styles.storeButton + " " + styles.storeButtonPending}
    type="button"
    disabled
    aria-label="Tiny JPG & PNG is coming soon to the Chrome Web Store"
  >
    <span className={styles.storeButtonIcon} aria-hidden="true">…</span>
    <span>
      <span className={styles.storeButtonLabel}>Coming soon</span>
      <span className={styles.storeButtonStatus}>Chrome Web Store</span>
    </span>
  </button>
);

export default TinyJpgPngStoreButton;
